import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import './index.css';

const TimePickerField = ({
  name,
  value,
  onChange,
  timeIntervals,
  timeFormat,
  disabled,
  isClearable,
}: {
  [key: string]: any;
}) => {
  const fieldProps: ReactDatePickerProps = {
    showTimeSelectOnly: true,
    showTimeSelect: true,
    timeIntervals: timeIntervals || 15,
    timeFormat: timeFormat || 'h:mm aa',
    dateFormat: 'h:mm aa',
    selected: (value && new Date(value)) || null,
    onChange: (val: any) => {
      onChange(name, val);
    },
    disabled,
    showMonthYearPicker: false,
    isClearable,
  };

  return (
    <div className="time-picker">
      <DatePicker {...fieldProps} />
    </div>
  );
};

export default TimePickerField;
